import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ImpersonateTransferConfirmationPostData } from 'src/app/lobby/shared/models/impersonation-transfer-confirmation-data';
import { TrasnferdAssistDetail } from 'src/app/lobby/shared/models/lobby-user-signin-status.model';
import { LobbyEntryService } from 'src/app/lobby/shared/services/lobby-entry.service';
import { State } from 'src/app/state/app.state';

@Component({
  selector: 'app-transfer-assist-info-popup',
  templateUrl: './transfer-assist-info-popup.component.html',
  styleUrls: ['./transfer-assist-info-popup.component.scss']
})
export class TransferAssistInfoPopupComponent {
  @Input()
  public transferFrom: string = '';
  @Input()
  public transferAssistDetails: TrasnferdAssistDetail[] = [];
  @Input()
  public dialogOpened: boolean = false;
  @Output() public dialogOpenedChange: EventEmitter<boolean> = new EventEmitter(false);
  impersonateTransferInfoSubs = new Subscription();
  @Output() public cancelled = new EventEmitter();
  constructor(private store: Store<State>, private lobbyEntryService: LobbyEntryService) { }

  public close() {
    this.cancelled.emit();
  }

  ngOnDestroy(): void {
    this.impersonateTransferInfoSubs.unsubscribe();
  }

  /**
 * Confirms the transfer of impersonated sessions.
 * Constructs an array of ImpersonateTransferConfirmationPostData from `transferAssistDetails`.
 * Calls `transferImpersonationConfirmation` API and emits a 'cancelled' event regardless of success or failure.
 */
  public confirmTransfer() {

    const impersonateTransferConfirmationPostDataList: ImpersonateTransferConfirmationPostData[] = [];
    this.transferAssistDetails.forEach((element, index) => {
      const impersonateTransferConfirmationPostData: ImpersonateTransferConfirmationPostData = {
        userSignInSessionId: element.userSignInSessionId
      };
      impersonateTransferConfirmationPostDataList.push(impersonateTransferConfirmationPostData);
    });

    this.lobbyEntryService
      .transferImpersonationConfirmation(impersonateTransferConfirmationPostDataList).subscribe((result: any) => {
        this.cancelled.emit();
      }, () => {
        this.cancelled.emit();
      })
  }
}
